import React, { FC } from "react";

const Required: FC = () => (
  <span style={{ color: "red" }} title="required">
    *
  </span>
);

export default Required;
